/** FuryBot firm detection — dynamic alias map + detectFirm() */

const FIRM_ALIAS_OVERRIDES = {
  "etf": "elite-trader-funding", "atf": "elite-trader-funding",
  "topstep": "topstep", "top step": "topstep",
  "apex": "apex", "apex trader": "apex", "apex funding": "apex",
  "bg": "blue-guardian", "blueguardian": "blue-guardian",
  "aqua": "aquafutures", "aqua futures": "aquafutures",
  "td": "tradeday", "trade day": "tradeday",
  "yrm": "yrm-prop", "e8": "e8-markets",
  "topone": "top-one-futures", "top1": "top-one-futures",
};

export function buildAliasMap(firmList) {
  const map = {};
  const suffixes = ["futures", "trading", "funding", "trader", "markets", "prop"];
  for (const f of firmList) {
    const name = f.name || "";
    const slug = f.slug || "";
    const lower = name.toLowerCase();
    map[lower] = slug;
    const words = lower.split(" ");
    if (words.length > 1 && suffixes.includes(words[words.length - 1])) {
      map[words.slice(0, -1).join(" ")] = slug;
    }
    map[slug.replace(/-/g, " ")] = slug;
    map[slug] = slug;
    map[lower.replace(/\s+/g, "")] = slug;
    if (words[words.length - 1].endsWith("s") && words[words.length - 1].length > 2) {
      const singular = [...words.slice(0, -1), words[words.length - 1].slice(0, -1)].join(" ");
      map[singular] = slug;
      const singWords = singular.split(" ");
      if (singWords.length > 1 && suffixes.includes(singWords[singWords.length - 1])) {
        map[singWords.slice(0, -1).join(" ")] = slug;
      }
    }
  }
  Object.assign(map, FIRM_ALIAS_OVERRIDES);
  return map;
}

export function detectFirm(text, aliasMap) {
  const normalized = text.toLowerCase().trim();
  const sortedAliases = Object.keys(aliasMap).sort((a, b) => b.length - a.length);
  for (const alias of sortedAliases) {
    if (normalized.includes(alias)) {
      return aliasMap[alias];
    }
  }
  return null;
}
